import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import PageBackdrop from '../components/PageBackdrop';
import { PAGE_BACKGROUNDS } from '../constants/brand';
import usePageTitle from '../hooks/usePageTitle';

const WORKSHOPS = [
  {
    id: 'intimacy-coordination',
    title: 'Intimacy Coordination Workshop',
    description:
      'Learn how intimate scenes are planned, choreographed, and performed safely and professionally for film and screen.',
  },
  {
    id: 'film-critique',
    title: 'Film Critique Workshop',
    description:
      'Develop the skills to analyze films beyond entertainment - understanding storytelling, direction, performance, and cinematic language.',
  },
  {
    id: 'film-festival-strategy',
    title: 'Film Festival Strategy Workshop',
    description:
      'Discover how to build a festival journey for your film, from selecting the right festivals to maximizing exposure and opportunities.',
  },
];

const Masterclasses = () => {
  usePageTitle('Masterclasses');
  return (
    <div className="min-h-screen bg-black film-grain pt-32 pb-24 relative overflow-hidden">
      <PageBackdrop imageUrl={PAGE_BACKGROUNDS.masterclasses} opacity={0.2} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 pt-20">
        <div className="text-center mb-16">
          <p className="chapter-label mb-8 !inline-block">MASTERCLASSES</p>
          <h1 className="display-heading text-5xl sm:text-7xl lg:text-8xl text-white mb-8" data-testid="masterclasses-heading">
          Coming <em>soon.</em>
          </h1>
          <div className="film-strip w-32 mx-auto mb-10"></div>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-2xl mx-auto">
            Exclusive sessions with working filmmakers - deep dives into craft, critique, and industry strategy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {WORKSHOPS.map((workshop, idx) => (
            <article
              key={workshop.id}
              data-testid={`workshop-card-${idx}`}
              className="cine-card p-8 border border-white/5 flex flex-col"
            >
              <span className="font-serif text-3xl text-[#C8102E] mb-4">0{idx + 1}</span>
              <h2 className="font-serif text-xl text-white mb-4 leading-snug">{workshop.title}</h2>
              <p className="text-sm text-zinc-400 leading-relaxed flex-1">{workshop.description}</p>
              <p className="mt-6 text-xs tracking-[0.2em] uppercase text-zinc-500">Coming soon</p>
            </article>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-zinc-500 mb-10">
            <Clock className="w-4 h-4 text-[#C8102E]" /> Programme launching late 2026
          </div>

          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/#waitlist" data-testid="masterclasses-waitlist-link" className="btn-cine-primary">
              Join the Waitlist
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/courses" className="btn-cine-outline">Browse Courses</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Masterclasses;
